// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"9ca4a9a7","703":"11823263"}[chunkId] + ".chunk.css";
};